import { render, staticRenderFns } from "./BookingClosedCard.vue?vue&type=template&id=4080b7b2&scoped=true&"
import script from "./BookingClosedCard.vue?vue&type=script&lang=js&"
export * from "./BookingClosedCard.vue?vue&type=script&lang=js&"
import style0 from "./BookingClosedCard.vue?vue&type=style&index=0&id=4080b7b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4080b7b2",
  null
  
)

export default component.exports